import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { summaryRows } from '../data/summary';
export function SummaryTable() {
  return <section className="py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-179" data-mp="o606ydatvopg">
      <div className="mx-auto max-w-4xl px-4" data-id="element-180" data-mp="o4713081h8ii">
        <SectionHeading id="summary-title" data-id="element-181" data-mp="j7yfb3zc6h2d">Tutto ciò che è <span className="text-accent" data-id="element-182" data-mp="j53v9dk8iy9h">incluso:</span></SectionHeading>

        <ul className="mt-10 grid overflow-hidden rounded-2xl border border-accent/20 bg-background/55 backdrop-blur-md sm:grid-cols-2" data-id="element-183" data-mp="1gtm7fcored83">
          {summaryRows.map(feature => <li key={feature} className="flex items-start gap-3 border-b border-accent/10 p-4 sm:odd:border-r" data-id="element-184" data-mp="16w83udnxpix7">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-accent shadow-glow" data-id="element-185" data-mp="12u4gaqnzqnvk">
                <CheckIcon className="h-3.5 w-3.5 text-background" aria-hidden="true" data-id="element-186" data-mp="3rojpgo3pfg72" />
              </span>
              <b className="text-sm text-foreground" data-id="element-187" data-mp="3nk3maulh6mvj">{feature}</b>
            </li>)}
        </ul>
      </div>
    </section>;
}